import { Link } from 'react-router-dom';
import { ChevronLeft, Leaf } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * /for-producers – Entry positioning page.
 * Curated, calm copy that invites the right hosts to qualify.
 */
export default function ForProducersEntry() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <div className="p-4">
        <Link
          to="/"
          className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
          <ChevronLeft className="h-4 w-4" />
          Tillbaka
        </Link>
      </div>

      <main className="flex-1 flex items-center justify-center px-6 pb-20">
        <div className="max-w-md w-full space-y-10 text-center">
          <Leaf className="h-8 w-8 text-muted-foreground/60 mx-auto" strokeWidth={1.5} />

          <h1 className="font-display text-2xl md:text-3xl text-foreground leading-tight">
            Farmly är inte för alla värdar.
          </h1>

          <div className="space-y-4 text-sm text-muted-foreground leading-relaxed">
            <p>Vi arbetar redaktionellt.</p>
            <p>Vi visar inte alla, hela tiden.</p>
            <p>Synlighet är inget löfte.</p>
            <p className="pt-2">Men för rätt plats kan Farmly bli något speciellt.</p>
            <p>Vårt mål är rätt gäster, i rätt takt.</p>
          </div>

          <Button variant="outline" className="mt-8" asChild>
            <Link to="/for-producers/qualify">Se om Farmly kan passa</Link>
          </Button>
        </div>
      </main>
    </div>
  );
}
